import { EB_BASVURU_OZELLIK_BY_MULTIROWT } from "../constants/requestUrls";
import { postRequest } from "../request";

const getEbBasvuruOzellikByMultiRowT = (props) => {
    let data = {};
    if (props !== undefined)
      data = JSON.stringify(props);
    return postRequest({ url: EB_BASVURU_OZELLIK_BY_MULTIROWT, data });
  }

export default getEbBasvuruOzellikByMultiRowT;